import { authed } from './auth'
import type { Channel, Message } from '@/types/api'

export interface SavedEntry {
  id: string
  channel_id: string
  message_id: string
  saved_at: string
  available: boolean
  channel?: Channel
  guild_name?: string
  message?: Message
}
export interface SavedPage { items: SavedEntry[]; has_more: boolean; next_before: string | null }
export interface SavedStatus { saved: boolean }
const path = (channelId: string, messageId: string) => `/channels/${channelId}/messages/${messageId}/saved`
export const savedApi = {
  list: (before?: string) => authed<SavedPage>(`/users/@me/saved-messages${before ? `?before=${encodeURIComponent(before)}` : ''}`),
  status: (channelId: string, messageId: string) => authed<SavedStatus>(path(channelId, messageId)),
  save: (channelId: string, messageId: string) => authed<void>(path(channelId, messageId), { method: 'PUT' }),
  remove: (channelId: string, messageId: string) => authed<void>(path(channelId, messageId), { method: 'DELETE' }),
}
export const savedStatusKey = (userId: string | undefined, channelId: string, messageId: string) => ['saved-message-status', userId, channelId, messageId] as const
